jQuery(document).ready(($) => {
    'use strict';


    $( document.body ).on( 'change', '.variations select', function(){
        $(this).find("option[value='']").attr('disabled','disabled');
        var variation_price = $('.woocommerce-variation-price .price').html();
        $('.variable').children('.price').html( variation_price );
    });

    $( document.body ).on( 'click', '.toggle-booking-cart', function(){
        $(this).hide();
        $('.cart').slideDown();
        $(this).siblings('.woocommerce-product-details__short-description, .woocommerce-product-details__short-description-preview').addClass('no-border');
    });

    $( document.body ).on( 'click', '.wc-bookings-booking-form-button', function(){
        $('#site-header').css('top', '0');
        if ( $('.cart-contents-count').length ) {
            $('.cart-contents-count').text( parseInt( $('.cart-contents-count').text() ) + 1 );
        } else {
            $('.cart-toggle').append('<span class="cart-contents-count">1</span>');
        }
        $('.cart-toggle').addClass('changed');
    });

    class Torget_Add_To_Cart {
        constructor() {
            $(document.body).on('click', '.add_to_cart_button, .single_add_to_cart_button:not(.wc-bookings-booking-form-button)', this.onAddToCart);
            $(document.body).on('added_to_cart removed_from_cart', this.onUpdatedFragments);

            $(document.body).on('click', '.quantity .minus', this.onQuantityChange.bind(this, -1));
            $(document.body).on('click', '.quantity .plus', this.onQuantityChange.bind(this, 1));
        }

        onQuantityChange(modifier, e) {
            e.preventDefault();

            const $target = $(e.target);
            const $input = $target.parent().find('input[type="number"]');

            const min = $input.attr('min') || 1;
            const max = $input.attr('max') || 9007199254740991;

            const newValue = parseInt($input.val(), 10) + modifier;

            $input.val(newValue < min ? min : newValue > max ? max : newValue);

            $input.trigger('change');
        }

        onAddToCart(e) {
            e.preventDefault();

            const $button = $(this);

            if ($button.hasClass('disabled')) {
                return;
            }

            const $form = $button.closest('form');

            $button.addClass('loading');

            const data = $form.serialize();

            $.ajax({
                    type: 'POST',
                    url: torget_add_to_cart_params.ajax_url.toString().replace('%%endpoint%%', 'add-to-cart'),
                    data: data,
                    dataType: 'json',
                    responseType: 'json',
                    contentType: "application/x-www-form-urlencoded;charset=utf-8",
                    cache: false
                })
                .always(() => $button.removeClass('loading'))
                .then(response => {
                        if (!response) {
                            return;
                        }

                        if (response.error) {
                            let message = 'Något gick fel.';

                            if (response.messages) {
                                message = response.messages[0];
                            }

                            const topic = 'Kunde inte lägga till produkten i varukorgen.';
                            new swal(topic, message, 'error');
                        } else {
                            if (response.data && response.data.fragments) {
                                // Trigger event so themes can refresh other areas.
                                $(document.body).trigger('added_to_cart', [response.data.fragments, response.data.cart_hash]);

                            }

                            $('#site-header').css('top', '0');
                            $('.cart-toggle').addClass('changed');
                            $button.addClass('added');

                            // Hide the cart after 2s.
                            setTimeout(() => {
                                $('.cart-toggle').removeClass('changed');
                                $button.removeClass('added');
                            }, 2000);
                        }
                    },
                    () => {
                        new swal('Något gick fel.', 'Vi upplever just nu lite problem. Var vänlig försök igen senare.', 'error');
                    },
                );
        }

        onUpdatedFragments = (e, fragments) => {
            $.each(fragments, (key, value) => {
                $(key).replaceWith(value);
            });
        };
    }

    new Torget_Add_To_Cart();
});
